var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultBotAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#E8E9EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.53 31.583C29.345 28.326 27.488 27.293 24.772 26.388C22.83 25.741 22.205 23.779 22.004 22.582",
    stroke: "#A8ACAF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.993 22.581C17.792 23.778 17.169 25.741 15.228 26.389C12.512 27.294 10.638 28.314 10.454 31.571",
    stroke: "#A8ACAF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 23C17.239 23 15 20.761 15 18V16C15 13.239 17.239 11 20 11C22.761 11 25 13.239 25 16V18C25 20.761 22.761 23 20 23Z",
    stroke: "#A8ACAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9846 20.7114C35.3773 12.4362 28.9873 5.40956 20.7121 5.01689C12.437 4.62421 5.41028 11.0142 5.01761 19.2894C4.62494 27.5645 11.015 34.5912 19.2901 34.9839C27.5653 35.3766 34.5919 28.9865 34.9846 20.7114Z",
    stroke: "#A8ACAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBotAvatar);
export default __webpack_public_path__ + "static/media/default-bot-avatar.d22167ab54680e4e5c589d546939975e.svg";
export { ForwardRef as ReactComponent };